import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { Guests } from "../components/Guests"

export function ServiceCenterGuestList() {
    return (
        <>
            <LocalizedStrict id="service-center-reports-dashboard-guests-page-header" attrs={{ title: true }}>
                <PageHeader page={Page.SERVICE_CENTER_REPORTS_GUESTS_ROUTE} title="Guests" />
            </LocalizedStrict>
            <Guests />
        </>
    )
}
